// import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import heroBackground from "src/assets/1househeropage.jpeg";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from "prop-types";

import { Box, Button, Stack, Link, ListItemText, CircularProgress, Modal, IconButton, Typography, Paper, Tooltip } from "@mui/material";

import {
    FormProvider,
    // RHFCheckbox,
    // RHFTextField,
    RHFLoginTextField
} from "src/components/hook-form";

import Password from "src/components/Password";
import ChoosePlan from "src/components/choose-plan";
import { LoadingButton } from "@mui/lab";
import Translate from "src/components/translate";
import { PATH_AUTH } from "src/routes/paths";
import AuthHelper from "src/pages/auth/Login/components/MainSection/login/components/authHelper/index.jsx"
import EnterOtp from "src/pages/auth/Login/components/MainSection/login/components/enter-otp/index.jsx"
import ErrorBanner from "src/pages/auth/Login/components/MainSection/login/components/error-banner.jsx"
import useLogin from "src/pages/auth/Login/components/MainSection/login/hooks/use-login.js"
import LanguagePopover from "src/layouts/shared/header/language-popover";

const LoginHeroSection = () => {
    //   const [openLaunchPopup, setOpenLaunchPopup] = useState(false);
    const [showLaunchPopup, setShowLaunchPopup] = useState(false); // New state for LaunchPopup
    const { onSubmit, methods } = useLogin();

    const {
        watch,
        formState: { isSubmitting },
    } = methods;

    const data = watch();
    const handleCloseLaunchPopup = () => {
        setShowLaunchPopup(false);
    };
    const handleLaunchPopup = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowLaunchPopup(true);
    };

    return (
        <Box
            component="section"
            sx={{
                position: "relative",
                minHeight: "95vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${heroBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    zIndex: 0,
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.6) 100%)",
                    zIndex: 1,
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "radial-gradient(ellipse at center, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%)",
                    zIndex: 2,
                }}
            />

            <Box
                sx={{
                    position: "relative",
                    zIndex: 3,
                    textAlign: "center",
                    px: { xs: 2, sm: 3 },
                    maxWidth: '48rem',
                    width: "56rem",
                    mx: "auto",
                }}
            >
                <Typography
                    component="h1"
                    sx={{
                        fontWeight: 700,
                        color: "#fff",
                        mb: { xs: 1, sm: 1 },
                        letterSpacing: "-0.02em",
                        fontSize: "clamp(2.5rem, 4vw + 1rem, 4.5rem)",
                        lineHeight: 1.15,
                    }}
                >
                    Stream Unlimited
                    <br />
                    Education
                </Typography>

                <Typography
                    sx={{
                        color: "rgba(255,255,255,0.8)",
                        mb: { xs: 1, sm: 1 },
                        //maxWidth: 640,
                        mx: "auto",
                        fontSize: "clamp(0.875rem, 1vw + 0.4rem, 1.25rem) !important",
                        lineHeight: 1.4,
                        fontWeight: 400,
                    }}
                >
                    Master new skills in Stocks, Real Estate, Day-Trading, Ecommerce, AI, Sports, Crypto, Fitness,
                    Business, Marketing, and Culinary arts from industry experts.
                </Typography>

                {/* <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 1, sm: 2 }}
                    justifyContent="center"
                    alignItems="center"
                > */}
                 <Box  // Changed from Stack to Box
                    sx={{
                        width: "100%",
                        maxWidth: "400px", // Set a max width for the form
                        mx: "auto", // Center the form
                    }}
                >

                    <FormProvider methods={methods} onSubmit={onSubmit}>
                        <Stack spacing={2} mb={2}>
                            <AuthHelper />
                            <ErrorBanner />
                        </Stack>

                        <Box>
                            <Stack spacing={1}>
                                <RHFLoginTextField name="email" label="register.email" placeholder="Email or Username" />
                                <Password name="password" label="register.password" placeholder="Password" />
                                <ChoosePlan />
                            </Stack>
                            <LoadingButton
                                fullWidth
                                // size="large"
                                type="submit"
                                variant="contained"  
                                loading={isSubmitting}
                                name="login"
                                sx={{
                                    mt: 1,
                                    px: "18px",
                                    py: "6px",
                                    // backgroundColor: "#e8f0ff",
                                    // color: "#000000",
                                    // '&:hover': {
                                    //     backgroundColor: "black",
                                    //     color: "white",
                                    // },
                                }}          >
                                <Typography variant="h6"><Translate>register.login</Translate></Typography>
                            </LoadingButton>

                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ my: 1 }}
                            >
                                {/* <RHFCheckbox name="remember" label="register.remember" /> */}
                                <Typography variant="body2"> <Translate>Having trouble logging in?</Translate> </Typography>
                                <Link
                                    component={RouterLink}
                                    variant="body2"
                                    sx={{
                                        color: "primary.main",
                                        paddingLeft: "3px"
                                    }}
                                    to={PATH_AUTH.resetPassword}
                                >
                                    <Translate>register.reset_password</Translate>
                                    {/* <Translate>register.forgot</Translate> */}
                                </Link>
                            </Stack>

                            {/* <GoogleOAuthButton
                        plan={methods.getValues("plan")}
                        buttonLabel="register.google_login"
                    /> */}

                            <LanguagePopover />
                        </Box>
                    </FormProvider>
                </Box>
            </Box>

            <Box
                sx={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: -1,
                    height: { xs: 20, md: 36 },
                    zIndex: 2,
                    overflow: "hidden",
                }}
            >
                <svg viewBox="0 0 1440 80" preserveAspectRatio="none" width="100%" height="100%">
                    <defs>
                        <linearGradient id="arcFade" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#1e8248" stopOpacity="0" />
                            <stop offset="15%" stopColor="#1e8248" stopOpacity="1" />
                            <stop offset="85%" stopColor="#1e8248" stopOpacity="1" />
                            <stop offset="100%" stopColor="#1e8248" stopOpacity="0" />
                        </linearGradient>

                    </defs>
                    <ellipse cx="720" cy="220" rx="850" ry="220" fill="none" stroke="url(#arcFade)" strokeWidth="3" />
                </svg>
            </Box>

        </Box>
    );
};

export default LoginHeroSection;
